import React, { useState, useEffect } from 'react';
import Button from '../Layout/Button'
import Dropdown from '../Layout/Dropdown'
import SelectOptions from '../Layout/SelectOptions';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import scrollToTop from '../Layout/scrollToTop';
// import visa from '../../assets/images/cardImages/visa.svg'
// import ae from '../../assets/images/cardImages/american-express.svg'
// import masterCard from '../../assets/images/cardImages/master-card.svg'
// import discover from '../../assets/images/cardImages/discover.svg'
// import dinnerClub from '../../assets/images/cardImages/diner-club.svg'
// import jcb from '../../assets/images/cardImages/jcb.png'
// import {ReactComponent as Spinner} from '../../assets/oval.svg';
// import {ReactComponent as SpinnerBlack} from '../../assets/oval-black.svg';
import {ReactComponent as Circles} from '../../assets/spinning-circles.svg';
import SuccessErrorPage from '../SuccessErrorPage'

export default function GiveOnline(props) {
  let date = new Date();
  let currentYear = date.getFullYear();
  const [values, setValues] = React.useState({
    giving_type: '',
    give_amount: '0.00',
    last_name: '',
    first_name: '',
    phone_number: '',
    email: '',
    card_number: '',
    cvv: '',
    month: '',
    year: date.getFullYear(),
    give_option: false,
    give_frequency: 'once',
    give_date: 'today',
    routing_number: '',
    account_number: '',
    memo: '',
    start_date: ''
  });
  const months = ["Month", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const [currentCard, setCurrentCard] = React.useState(0);
  const [giveAmountError, setGiveAmountError] = React.useState(false)
  const [processingGiving, setProcessingGiving] = useState(false);
  const [processingComplete, setProcessingComplete] = useState(false);
  const [processingError, setProcessingError] = useState(false);
  const [processingMessage, setProcessingMessage] = useState('');
  const [useCredit, setUseCredit] = useState(true);
  const [giveTypes, setGiveTypes] = useState(props.giving_type);
  const [startDate, setStartDate] = useState(new Date());
  const [currentCardType, setCurrentCardType] =  useState(false);
  const cardValidation = {
    visa: [/^(?:4[0-9]{12}(?:[0-9]{3})?)$/, 'https://dev.churchpad.com/cp/mediavault/visa.svg'],
    amex: [/^(?:3[47][0-9]{13})$/, 'https://dev.churchpad.com/cp/mediavault/american-express.svg'],
    mastercard: [/^(?:5[1-5][0-9]{14})$/, 'https://dev.churchpad.com/cp/mediavault/master-card.svg'],
    discover: [/^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/, 'https://dev.churchpad.com/cp/mediavault/discover.svg'],
    dinnerclub: [/^(?:3(?:0[0-5]|[68][0-9])[0-9]{11})$/, 'https://dev.churchpad.com/cp/mediavault/diner-club.svg'],
    jcb: [/^(?:(?:2131|1800|35\d{3})\d{11})$/, 'https://dev.churchpad.com/cp/mediavault/jcb.svg']
  }

  let resetAll = () => {
    setValues({
      giving_type: '',
      give_amount: '0.00',
      last_name: '',
      first_name: '',
      phone_number: '',
      email: '',
      card_number: '',
      cvv: '',
      month: '',
      year: date.getFullYear(),
      give_option: false,
      give_frequency: 'once',
      give_date: 'today',
      routing_number: '',
      account_number: '',
      memo: '',
      start_date: ''
    });
    setGiveAmountError(false);
    setProcessingGiving(false);
    setProcessingComplete(false);
    setProcessingError(false);
    setUseCredit(true);
    setGiveTypes(props.giving_type);
    setStartDate(new Date());
    setCurrentCardType(false);
    setCurrentCard(0);
  }

  let reenterCard = () => {
    setValues({
      ...values, 
      card_number: '',
      cvv: '',
      month: '',
      year: date.getFullYear(),
    });
    setCurrentCard(0);
    setCurrentCardType(false);
    setUseCredit(true);
    setProcessingError(false);
    setProcessingComplete(false);
    setProcessingGiving(false);
  }

  React.useEffect(() => {
    let cardType = isValidCard(values.card_number);
    if(cardType === 'amex') {
      let card_number =  values.card_number.split(' ').join('');
      card_number = card_number.replace(/\b(\d{4})(\d{6})(\d{5})\b/, '$1 $2 $3');
      setValues({ ...values, card_number: card_number });
    }
    setCurrentCardType(cardType);
  }, [values.card_number])

  const isValidCard = (cardNumber) => {
    cardNumber = cardNumber.split(' ').join('');
    for (const key in cardValidation) {
      if(cardNumber.match(cardValidation[key][0]) && props.allowedCardOptions.includes(key)) {
        return key;
      }
    }
    return false;
  }

  let infoProps = [['first_name', 'last_name', 'email'], ['giving_type', 'give_frequency'], [['card_number', 'cvv', 'month', 'year'], ['account_number', 'routing_number']]]

  let runAfterUpdate = useRunAfterUpdate();

  const handleChange = (prop) => (event) => {
    let value = event.target.value;
    let id = event.target.id;
    singleErrorCheck(id, value);
    if(id === 'phone_number' || id === 'card_number' || id === 'cvv' || id === 'account_number' || id === 'routing_number') {
      value = value.split('-').join('');
      if(!isNumber(value)) {return}
      if(id === 'phone_number') {
        if(value.length >= 16) {
          return
        }
        value = value.length < 11 ? formatPhoneNumber(value) : value;
      } else if(id === 'cvv' && value.length > 4) {
        return
      }
    }
    if(id === 'give_amount') {
      if(!value) {value = '0.00'}
      let val = value.replace('.', '');
      if(!isNumber(val) && !val.includes(',')) {
        return
      } else {
        val = Number(value);
        if(!value.includes('.')){
          value = value.split('');
          value.splice(value.length - 2, 0, '.');
          value = value.join('')
        }
        if(val > 999999.99) {return}
        // if(value.length < 4) {return}
        // let newVal = value.split('.'); // split value into 2;
        // newVal.pop(); // remove the decimals
        let decimalValue = value.split('.')[1]; // get decimal value from original
        let decimalLen = decimalValue.length; //get its length
        if(decimalLen > 2 || decimalLen < 2) {
          if(value === '0.00') {
            setValues({ ...values, [prop]: value });
            return
          }
          const input = event.target;
          const cursorPos = event.target.selectionStart;
          runAfterUpdate(() => {
            input.selectionStart = cursorPos;
            input.selectionEnd = cursorPos;
          });
          let newValue = formatDecimal(value);
          if(Number(newValue) > props.maxDonation) {return}
          if(newValue.split('.')[1].length === 2) {
            value = newValue;
          } else {
            return
          }
        }
      }
    }
    if(id === 'card_number') {
      let newVal = formatCardNumber(value);
      value =  newVal;
    }
    setValues({ ...values, [prop]: value });
  };

  function useRunAfterUpdate () {
    const afterPaintRef = React.useRef(null);
    React.useLayoutEffect(() => {
      if(afterPaintRef.current) {
        afterPaintRef.current();
        afterPaintRef.current = null;
      }
    });
    const runAfterUpdate = fn => (afterPaintRef.current = fn);
    return runAfterUpdate;
  }

  let formatDecimal = (value) => {
    let valuesArry = value.split('.');
    let decimal = valuesArry[1] ? valuesArry[1] : ''
    let wholeNum = valuesArry[0]
    let newValue = value

    if(decimal.split('').length > 1) {
      decimal = valuesArry[1] ? valuesArry[1].split('') : [];
      wholeNum = valuesArry[0] ? valuesArry[0].split('') : [];
      wholeNum.push(decimal[0]);
      decimal.shift();
      if(wholeNum[0] === '0') {
        wholeNum.shift();
      }
      wholeNum = wholeNum.join('');
      decimal = decimal.join('');
      newValue = [wholeNum, decimal].join('.');
    } else {
      wholeNum = [...wholeNum.split('')];
      decimal = [wholeNum[wholeNum.length - 1], decimal];
      wholeNum.pop();
      if(wholeNum.length < 1) {
        wholeNum.push('0');
      }
      newValue = [wholeNum.join(''), decimal.join('')].join('.');
    }
    
    return newValue;
  } 

  const handleSelection = (id, selected) => {
    singleErrorCheck(id, selected);
    setValues({ ...values, [id]: selected });
  };

  let errorTarget = (id, value) => {
    let errors = false;
    let errorStyle = (style) => {
      if(document.getElementById(`${id}-container`)) {
        document.getElementById(`${id}-container`).style.border = style
      }
    }
    if(value.length < 1){
      errorStyle('1px solid #ef4b4b')
      errors = true;
    } else if (id === 'email') {
      if(!emailValidation(value)) {
        errorStyle('3px solid #5e76e8')
        errors = true;
      } else {
        errorStyle('');
      }
    } else if(id === 'card_number') {
      if(!isValidCard(value)) {
        errorStyle('1px solid #ef4b4b')
        errors = true;
      } else {
        errorStyle('');
      }
    } else if(id === 'give_frequency') {
      if(value === 'Select one') {
        errorStyle('1px solid #ef4b4b')
        errors = true;
      } else {
        errorStyle('');
      }
    } else if(id === 'giving_type') {
      if(value === 'Select one') {
        errorStyle('1px solid #ef4b4b');
        errors = true;
      } else {
        errorStyle('');
      }
    } else {
      errorStyle('');
    }
    return errors;
  }

  let globalErrorCheck = () => {
    let errors = [];
    let keys = infoProps[currentCard];
    if(currentCard === 2) {
      if(useCredit) {
        keys = keys[0];
      } else {
        keys = keys[1];
      }
    }
    for(let i = 0; i < keys.length; i++) {
      let id = keys[i];
      let value = values[id];
      errors.push(errorTarget(id, value));
    }
    errors = errors.includes(true) ? true : false;
    return errors;
  }

  const singleErrorCheck = (target, value) => {
    if(target) {
      errorTarget(target, value);
      return 0;
    }
  }

  const emailValidation = (string) => {
    let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if(string.match(mailFormat)){
      return true;
    } else {
      return false;
    }
  }

  const isNumber = (value) => {
    let validNumbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
    value = value.split(' ').join('');
    for(let i = 0; i < value.length; i++) {
      if(!validNumbers.includes(value[i])) {
        return false;
      }
    }
    return true;
  }

  const switchCard = (e) => {
    let direction = e.target.id;
    let currentCardValue = currentCard;
    if(Number(values.give_amount) < props.minDonation || Number(values.give_amount) > props.maxDonation) {
      setGiveAmountError(`The value must be greater than ${formatGiveAmount(props.minDonation)} ${props.currency} and less than ${formatGiveAmount(props.maxDonation)} ${props.currency}`);
      globalErrorCheck();
      scrollToTop();
      return;
    } else {
      setGiveAmountError(false);
    }
    if(direction === 'back') {
      currentCardValue = currentCardValue > 0 ? currentCardValue - 1 : 0;
    } else if(direction === 'forward' && !globalErrorCheck()) {
      currentCardValue = currentCardValue < activeStep.length - 1 ? currentCardValue + 1 : 0;
    } else {
      return
    }
    setCurrentCard(currentCardValue);
  }

  let formatPhoneNumber = (phoneNumberString) => {
    phoneNumberString = phoneNumberString.split('-').join('');
    let newString = phoneNumberString.split('');
    if(newString.length > 3) {
      newString.splice(3, 0, '-');
      if(newString.length > 7) {
        newString.splice(7, 0, '-');
      }
    };
    newString = newString.join('');
    return newString
  }

  let formatGiveAmount = (value_) => {
    let value = value_.split('.')[0].split('')
    let iterate = 0;
    for(let i = value.length; i > 0; i--) {
      if(iterate % 3 === 0 && iterate > 0) {
        value.splice(i, 0, ',');
      }
      iterate++;
    }
    value = value.join('');
    value = [value, (value_.split('.')[1])].join('.')
    return value;
  }

  const formatCardNumber = (string) => {
    var v = string.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
    var matches = v.match(/\d{4,16}/g);
    var match = matches && matches[0] || ''
    var parts = []

    for (let i=0, len=match.length; i<len; i+=4) {
        parts.push(match.substring(i, i+4))
    }

    if (parts.length) {
        return parts.join(' ')
    } else {
        return string
    }
  }

  let selectOption = (prop, option) => {
    setValues({ ...values, [prop]: option });
  }

  useEffect(() => {
    if(values.give_option === 'Recurring Giving') {
      setValues({...values, give_frequency: values.give_frequency === 'once' ? 'Select one' : values.give_frequency})
    } else {
      setValues({...values, give_frequency: 'once'})
    }
  }, [values.give_option])

  let giveWithCard = () => {
    if(currentCard < 3 || processingGiving) {return}
    let tok =  btoa(`${props.unicycle}:${props.pencil}`);
    const cardNumber = btoa(values.card_number.split(' ').join(''))
    let phone_number = values.phone_number.split('-').join('');
    let data = JSON.stringify({
      "orgId": props.orgId,
      "amount": values.give_amount,
      "contributionType": values.giving_type,
      "firstName": values.first_name,
      "lastName": values.last_name,
      "cardNumber": cardNumber,
      "expirationMonth": months.indexOf(values.month),
      "expirationYear": values.year,
      "cvv": values.cvv,
      "recurring": values.give_frequency,
      'recurringStartDate':values.start_date,
      "mobile": phone_number,
      "email": values.email,
    })
    setProcessingGiving(true)
    setValues({...values, card_number: ''});

    axios.post('https://api.churchpad.com/p/give-with-card/', data, {
        headers: { 
            'Authorization' : `Basic ${tok}`,
            'Content-Type': 'application/json',
        },
    }).then(res => {
      if(res.data.responseCode === '00') {
        setProcessingComplete(true);
        setProcessingError(false);
        setProcessingMessage(res.data.responseMessage);
      } else {
        setProcessingComplete(true);
        setProcessingError(true);
        setProcessingMessage(res.data.responseMessage);
      }
      
    }).catch(err => {
        console.log(err);
    })
  }

  let giveWithCheck = () => {
    if(currentCard < 3 || processingGiving) {return}
    let tok =  btoa(`${props.unicycle}:${props.pencil}`);
    const accountNumber = btoa(values.account_number)
    let phone_number = values.phone_number.split('-').join('');
    let data = JSON.stringify({
      "orgId": props.orgId,
      "amount": values.give_amount,
      "contributionType": values.giving_type,
      "firstName": values.first_name,
      "lastName": values.last_name,
      "accountNumber": accountNumber,
      "routingNumber": values.routing_number,
      "recurring": values.give_frequency,
      'recurringStartDate':values.start_date,
      "mobile": phone_number,
      "email": values.email,
      "memo": values.memo
    });
    setProcessingGiving(true);
    setValues({...values, card_number: ''});

    axios.post('https://api.churchpad.com/p/give-with-check/', data, {
        headers: { 
            'Authorization' : `Basic ${tok}`,
            'Content-Type': 'application/json',
        },
    }).then(res => {
      if(res.data.responseMessage === 'success') {
        setProcessingComplete(true);
        setProcessingError(false);
      } else {
        setProcessingComplete(true);
        setProcessingError(res.data.responseMessage);
      }
      
    }).catch(err => {
        console.log(err);
    })
  }

  useEffect(() => {
    setGiveTypes(props.giving_type)
  }, [props])
  useEffect(() => {
    let newDate = startDate;
    let month = newDate.getMonth();
    let date = newDate.getDate();
    let year = newDate.getFullYear();
    let newStartDate = `${month + 1}/${date}/${year}`;
    setValues({ ...values, start_date: newStartDate });
  }, [startDate])

  let activeStep = [ 
      <>
        <div className="giver-info">
          <header>
            <div className="header-content">
              <span style={{backgroundColor: props.colors.secondary}}><i className="las la-user"></i></span>
              <h3>Your Information</h3>
            </div>
          </header>
          <div className="givers-name">
            <div className="row">
              <form className="col s12">
                <div className="row">
                  <div className="input-field col s6" id="first_name-container">
                    <input id="first_name" type="text" className="validate" onChange={handleChange('first_name')} value={values.first_name}/>
                    <label htmlFor="first_name" className={values.first_name.length > 1 ? 'active' : ''}>First Name<sup>*</sup></label>
                  </div>
                  <div className="input-field col s6" id="last_name-container">
                    <input id="last_name" type="text" className="validate" onChange={handleChange('last_name')} value={values.last_name}/>
                    <label htmlFor="last_name"  className={values.last_name.length > 1 ? 'active' : ''}>Last Name<sup>*</sup></label>
                  </div>
                </div>
                <div className="row">
                  <div className="input-field col s6" id="phone_number-container">
                    <input id="phone_number" type="text" className="validate" onChange={handleChange('phone_number')} value={values.phone_number}/>
                    <label htmlFor="phone_number"  className={values.phone_number.length > 1 ? 'active' : ''}>Phone Number</label>
                    <h4 className="input-sub-text">(To get your giving notification by text)</h4>
                  </div>
                  <div className="input-field col s6" id="email-container">
                    <input id="email" type="email" className="validate" onChange={handleChange('email')} value={values.email}/>
                    <label htmlFor="email"  className={values.email.length > 1 ? 'active' : ''}>Email</label>
                    <h4 className="input-sub-text">(To get your giving notification by email)</h4>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>,
          <div className="giver-info">
            <header>
              <div className="header-content">
                <span style={{backgroundColor: props.colors.secondary}}><i className="las la-donate"></i></span>
                <h3>Pick give type</h3>
              </div>
            </header>
            <div className="giving_type_recurring">
              <SelectOptions
                options={['Give once', 'Recurring Giving']}
                icons={['las la-donate', 'las la-sync']}
                title='Give Option'
                type={'give_option'}
                selectedOption={values.give_frequency === 'once' ? 'Give once' : 'Recurring Giving'}
                colors={props.colors}
                selectOption={selectOption}
              />
              {values.give_option === 'Recurring Giving' ?
                <>
                <SelectOptions
                  options={["Select one", ...props.give_frequency]}
                  title={'Give Frequency'}
                  colors={props.colors}
                  type={'give_frequency'}
                  selectOption={selectOption}
                  selectedOption={values.give_frequency === 'once' ? 'Select one' : values.give_frequency}
                />
                  <div className="start_date-container container">
                    <DatePicker
                      selected={startDate}
                      onChange={date => setStartDate(date)}
                      minDate={new Date()}
                      maxDate={new Date(date.setMonth(date.getMonth()+1))}
                      showDisabledMonthNavigation
                    />
                  </div>
                </>
               : null}
               <div className="give-types">
                  <label>Giving Type</label>
                  <div className="dropdown-container" id="giving_type-container">
                      <Dropdown
                        placeholder={values.giving_type}
                        value={values.giving_type}
                        dropDownItems={['Select one', ...giveTypes]}
                        hasSearch={false}
                        hasInput={false}
                        closeAll={false}
                        type={'string'}
                        id={'giving_type'}
                        handleSelection={handleSelection}
                    />
                  </div>
              </div>
            </div>
          </div>,
        <div className="row user-card-details">
          {
            (useCredit === false && props.allowsCheck === true) ? 
            <>
            <header>
              <div className="header-content">
                <span style={{backgroundColor: props.colors.secondary}}><i className="las la-money-check"></i></span>
                <h3>Credit details</h3>
              </div>
            </header>
            <form className="col s12">
              <div className="row">
                <div className="input-field col s12 userCardNumber" id="account_number-container">
                  <input id="account_number" type="text" className="validate" onChange={handleChange('account_number')} value={values.account_number}/>
                  <label htmlFor="account_number"  className={values.account_number.length > 1 ? 'active' : ''}>Account Number<sup>*</sup></label>
                </div>
              </div>
              <div className="row">
                <div className="input-field col s12" style={{width: '100%'}} id="routing_number-container">
                  <input id="routing_number" type="text" className="validate" onChange={handleChange('routing_number')} value={values.routing_number}/>
                  <label htmlFor="routing_number"  className={values.routing_number.length > 1 ? 'active' : ''}>Routing Number<sup>*</sup></label>
                </div>
              </div>
              <div className="row">
                <div className="input-field text-field col s12" style={{width: '100%'}} id="memo-container">
                  <textarea id="memo" type="text" className="validate" onChange={handleChange('memo')} value={values.memo}></textarea>
                  <label htmlFor="memo"  className={values.memo.length > 1 ? 'active' : ''}>Memo</label>
                </div>
              </div>
            </form>
            {props.allowsCheck ? <button className="waves-effect" onClick={() => setUseCredit(true)} style={{padding:'7px', borderRadius: '4px'}}><h4 className="">Pay with Card</h4></button> : null}
            </>
            :
            <>
            <header>
              <div className="header-content">
                <span style={{backgroundColor: props.colors.secondary}}><i className="las la-credit-card"></i></span>
                <h3>Card details</h3>
              </div>
            </header>
            <form className="col s12">
              <div className="row">
                <div className="input-field col s12 userCardNumber" id="card_number-container">
                  <input id="card_number" type="text" className="validate" onChange={handleChange('card_number')} value={values.card_number}/>
                  <label htmlFor="card_number"  className={values.card_number.length > 1 ? 'active' : ''}>Card Number<sup>*</sup></label>
                  <span className="card-type" style={currentCardType ? {backgroundColor: `${cardValidation[currentCardType][1]}`} : {}}>
                    {
                      currentCardType ? <img src={cardValidation[currentCardType][1]} alt={currentCardType}/> : null
                    }
                  </span>
                </div>

                {
                  props.allowedCardOptions && currentCardType === false ? 
                    <div className="allowedCards">Acceptable cards: {props.allowedCardOptions.map((item, index) => {
                      return (
                        <span key={index}>{item}{index === props.allowedCardOptions.length - 1 ? '' : ','}</span>
                      )
                    })} </div> : null
                  }
              </div>
              <div className="row cardExpireDate">
                <div className="input-field col s6" id="month-container">
                  <Dropdown
                    placeholder={values.month}
                    value={values.month}
                    dropDownItems={["Month", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]}
                    hasSearch={false}
                    hasInput={false}
                    closeAll={false}
                    type={'string'}
                    id={'month'}
                    handleSelection={handleSelection}
                  />
                </div>
                <div className="input-field col s6" id="year-container">
                  <Dropdown
                    placeholder={values.year}
                    value={values.year}
                    range={[currentYear, currentYear + 20]}
                    hasSearch={false}
                    hasInput={false}
                    closeAll={false}
                    type={'string'}
                    id={'year'}
                    handleSelection={handleSelection}
                  />
                </div>
              </div>
              <div className="row userCvv">
                <div className="input-field col s6" id="cvv-container">
                  <input id="cvv" type="text" className="validate" onChange={handleChange('cvv')} value={values.cvv}/>
                  <label htmlFor="cvv"  className={values.cvv.length > 1 ? 'active' : ''}>cvv<sup>*</sup></label>
                  <h4 className="input-sub-text">3 or 4 digit usually found on the signature strip</h4>
                </div>
              </div>
            </form>
            {props.allowsCheck ? <button className="pay-with waves-effect" onClick={() => setUseCredit(false)} style={{padding:'7px', borderRadius: '4px'}}><h4 className="">or pay with Check...</h4></button> : null}
            </>
          }
        </div>,
        <div className="reviewGiving">
          <header>
            <div className="header-content">
              <span style={{backgroundColor: props.colors.secondary}}><i className="las la-clipboard-list"></i></span>
              <h3>Review Details</h3>
            </div>
          </header>
          <div className="review">

            {/* <p> */}
              {/* With this card, you would like to give {values.give_amount} as {values.giving_type}
              <span>The payment will go ou</span> */}
              {/* Process a gift of $100 as offering. 
              Your payment will go out on March 12, 2020 and a confirmation will be sent to your email jmoney@yahoo.com */}
            {/* </p> */}

            {useCredit ? <div className="credit-card-details" style={{backgroundColor: props.colors.background}}>
              <div className="card-info">
                <span className="card-number">
                  <h4>{'Card'} ending in {values.card_number.split(' ')[3]}</h4>
                </span>

                <span className="expire-date">
                  <h4>{values.month}/{values.year}</h4>
                  <i className="lar la-star"></i>
                </span>
              </div>
            </div> : null}

            <div className="final-give-info-container">
              <div className="final-give-info">
                <h4>
                  Name: 
                </h4>
                <p>
                  {values.first_name} {values.last_name}
                </p>
              </div>

              <div className="final-give-info">
                <h4>
                  Amount:
                </h4>
                <p>
                  {values.give_amount} {props.currency}
                </p>
              </div>

              <div className="final-give-info">
                <h4>
                  Type:
                </h4>
                <p>
                  {values.giving_type}
                </p>
              </div>

              <div className="final-give-info">
                <h4>
                  Recurring:
                </h4>
                <p>
                  {values.give_frequency === 'once' ? 'None' : values.give_frequency}.
                </p>
              </div>

              <div className="final-give-info">
                <h4>
                  Email:
                </h4>
                <p>
                  {values.email}
                </p>
              </div>

              <div className="final-give-info">
                <h4>
                  Phone:
                </h4>
                <p>
                  {values.phone_number}
                </p>
              </div>
              
              <div className="final-give-info">
                <h4>
                  {values.give_frequency === 'once' ? 'Date' : 'Start Date'}:
                </h4>
                <p>
                  {values.start_date}
                </p>
              </div>
            </div>
          </div>
        </div>
  ]

  let lastCard = currentCard >= activeStep.length - 1;
  
  return (
    <>
    {processingComplete ? 
      <SuccessErrorPage
        colors={props.colors}
        orgId={props.orgId}
        type={processingError ? 'error' : 'success'}
        message={processingMessage}
        ctas={processingError ? 
        [
          {
            message: 'Go back?',
            location: 'give-online',
            customFunction: reenterCard
          },
        ] : [
          {
            message: 'Give again?',
            location: 'give-online',
            customFunction: resetAll
          },
          {
            message: 'Sign In?',
            location: 'signin'
          }
        ]}
      /> : <div className="check-out-container">
      <div className="GiveOnline">
        {
          currentCard >= activeStep.length - 1 ? null : 
            <div className="give-amount">
              <h3>{currentCard > 0 ? `` : 'Give amount'}</h3>
              <div className="inputContainer" id="give_amount-container">
                {/* <i className="fas fa-dollar-sign"></i> */}
                {/* <input type="text" value="100.00"/> */}
                <input id="give_amount" type="text" onChange={handleChange('give_amount')} value={values.give_amount}/>
                <h4 style={{
                    position: 'absolute',
                    color: 'white',
                    bottom: '-30px',
                    fontWeight: 900 
                }}>{currentCard > 1 ? `Giving Type: ${values.giving_type}` : ''}</h4>
                <div className="inputCopy">
                  <div className="inputValueCopy">
                    <h4 className="currency-type">{props.currency}</h4>
                    {formatGiveAmount(values.give_amount)}
                  </div>
                </div>
               {
                 giveAmountError ?  <div className="give-error">
                  <span>
                    <i className="las la-exclamation"></i>
                  </span>
                  <h4 className="error_message">{giveAmountError}</h4>
                </div> : null
               }
              </div>
            </div>
        }

        <div className="givers-info" style={lastCard ? {marginTop: '70px'} : {}}>
          {processingGiving ? 
            <div className="processingPayment">
              <header>
                <div className="header-content">
                  <span style={{backgroundColor: props.colors.secondary}} className="black"><i className="las la-exclamation"></i></span>
                  <h3>Processing Giving</h3>
                </div>
              </header>
              <div className="spinner">
                <Circles/>
              </div>
            </div> 
            :
            <>
              {activeStep[currentCard]}
            </>
          }
          <div className="actionButtons">
            {processingGiving ? null : 
              <>
                <Button className={"back-button button "} style={{backgroundColor: lastCard ? props.colors.secondary : props.colors.secondary, display: currentCard > 0 ? 'inline-block' : 'none'}} 
                onClick={lastCard ? (useCredit ? giveWithCard : giveWithCheck) : switchCard}
                id={'back'}>
                  <h4 className="button-text" id={'back'}>{currentCard === activeStep.length - 1 ? 'Process' : 'Back'}</h4>
                </Button>
                <Button className="next-button button" style={{backgroundColor: lastCard ? '#222' : props.colors.secondary}} 
                  onClick={processingGiving ? console.log('Stop') : lastCard ? () => {setCurrentCard(0)} : switchCard}
                  id={'forward'}>
                  <h4 className="button-text" id={'forward'}>{currentCard === activeStep.length - 1 ? 'Cancel' : 'Next'}</h4>
                </Button>
              </>
            }
          </div>
        </div>
      </div>
    </div>}
    </>
  );
}